import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'

export const getValueByKey = (
  options: OptionsItem[],
  key: string | undefined
): string => options.find(x => x.key === key)?.text || options?.[0]?.text || ''
